<div id="mainportalpage" [ngStyle]="{ height: height, width: width }" class="wrapper">
    <div class="account-summary por-ac-summary" [ngClass]="{ loading: isLoading }">
        @if (!(customerSummary$ | async | count)) {
        <ngx-skeleton-loader count="4" count="4" appearance="circle"></ngx-skeleton-loader>
        } @else {
        <div class="account-summary-details">
            <div class="details-section">
                @if (customer$ | async | count) {
                <div>
                    <p class="theme-paragraph">
                        {{ (customer$ | async)?.Name }}
                    </p>
                </div>
                }
            </div>
            <div class="summary-section">
                @if (appFacadeService.isAccountFeaturesLoaded() | async) { @if (appFacadeService.featureToggleService.isAvailable('Account.ViewContracts')) {
                <div (click)="openContractsAndFilter('Quote')" porAddFeature featureName="account-summary-quotes-button">
                    <h3 class="theme-heading">
                        {{ (customerSummary$ | async)?.totalQuotes ?? 0 }}
                    </h3>
                    <span class="theme-paragraph">{{ 'Quotes' | translate }}</span>
                </div>
                <div (click)="openContractsAndFilter('Open')" porAddFeature featureName="account-summary-open-button">
                    <h3 class="theme-heading">
                        {{ (customerSummary$ | async)?.totalOpen ?? 0 }}
                    </h3>
                    <span class="theme-paragraph">{{ 'Open' | translate }}</span>
                </div>
                <div (click)="openContractsAndFilter('Reservation')" porAddFeature featureName="account-summary-reservation-button">
                    <h3 class="theme-heading">
                        {{ (customerSummary$ | async)?.totalReservation ?? 0 }}
                    </h3>
                    <span class="theme-paragraph">{{ 'Reservations' | translate }}</span>
                </div>
                <div (click)="openContractsAndFilter('Returned')" porAddFeature featureName="account-summary-returned-button">
                    <h3 class="theme-heading">
                        {{ (customerSummary$ | async)?.totalReturned ?? 0 }}
                    </h3>
                    <span class="theme-paragraph">{{ 'Returned' | translate }}</span>
                </div>
                }}
            </div>
        </div>
        }
        <por-ad-images [customerId]="customerId" [loading]="isLoading" [layout]="'columns2'"></por-ad-images>
    </div>
</div>
